import React from "react";

import SidebarProperties from "./sidebar.component";
import SidebarPropertiesSus from "./sidebarSus.component";
import close from "./../../../UI/general/close.svg";

interface PropertiesContainer {
  propertiesRef: any
}
interface Props {
  isProperties: boolean;
  colorsData: boolean;
  inmueblesData: any;
  handlePropertiesFilter: any;
  avalabilityAttributesToShow: any;
  handleFilterAvailability: any;
  handleMenuSelection: any;
  isDetailed: any;
  handleCloseDetailedSpin: any;
  hasDispo: boolean;
  detailedGroupID: any,
  isSalaVentasMode: boolean,
  layoutsRef: any,
  handleHideTooltip: any
}

interface State {
  inmueblesData: any;
  attributesFilterObject: any;
  isDetailed: boolean;
  wordToShow: string
}

class PropertiesContainer extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      inmueblesData: {},
      attributesFilterObject: {},
      isDetailed: false,
      wordToShow: ''
    };

    this.propertiesRef = React.createRef()
  }

  componentDidMount = async () => {
    this.props.inmueblesData.properties.attributes.map((attribute: any) => {
      if(attribute.type === 'Hierarchical' && attribute.padre !== null){
        this.setState({
          wordToShow: attribute.name
        })
      }

      return 0
    })
    this.createAttributesFilterStructure();
    if (this.props.isDetailed.group) {
      this.setState({
        isDetailed: true,
      });
    }
  };

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>,
    snapshot?: any
  ): void {
    if (
      this.props.isDetailed !== prevProps.isDetailed &&
      this.props.isDetailed.group
    ) {
      this.setState({
        isDetailed: true,
      });
    }
  }

  createAttributesFilterStructure = () => {
    var attributesFilterObject: any = {};

    this.props.inmueblesData.properties.attributes.map(
      (attribute: any, index: number) =>
        (attributesFilterObject[attribute.id] = [])
    );

    this.setState({
      attributesFilterObject: attributesFilterObject,
    });
  };

  handleUpdateFilterObject = (payload: any) => {
    this.setState(
      {
        attributesFilterObject: payload,
      },
      () => {
        this.props.handlePropertiesFilter(this.state.attributesFilterObject);
      }
    );
  };

  handleClearFilters = () => {
    var attributesFilterObject: any = {};

    this.props.inmueblesData.properties.attributes.map(
      (attribute: any, index: number) =>
        (attributesFilterObject[attribute.id] = [])
    );

    this.setState(
      {
        attributesFilterObject: attributesFilterObject,
      },
      () => {
        this.props.handlePropertiesFilter(this.state.attributesFilterObject);
      }
    );
  };

  render(): React.ReactNode {
    return (
      <div
        className={
          this.props.isProperties
            ? "properties-container fade-in"
            : "properties-container fade-out"
        }
      >
        {this.props.inmueblesData.properties && this.props.inmueblesData.type_filter === 1 && this.props.isProperties ? (
          <SidebarProperties
            ref = {this.propertiesRef}
            colorsData={this.props.colorsData}
            inmueblesData={this.props.inmueblesData}
            attributesFilterObject={this.state.attributesFilterObject}
            handleUpdateFilterObject={this.handleUpdateFilterObject}
            handlePropertiesFilter={this.props.handlePropertiesFilter}
            avalabilityAttributesToShow={this.props.avalabilityAttributesToShow}
            handleFilterAvailability={this.props.handleFilterAvailability}
            handleMenuSelection={this.props.handleMenuSelection}
            handleClearFilters={this.handleClearFilters}
            isProperties={this.props.isProperties}
            hasDispo={this.props.hasDispo}
            //isDetailed={this.state.isDetailed}
            detailedGroupID = {this.props.detailedGroupID}
            //currentDetailed={this.props.isDetailed}
            //wordToShow={this.state.wordToShow}
            layoutsRef = {this.props.layoutsRef}
            handleHideTooltip = {this.props.handleHideTooltip}
          />
        ) : null}
        {this.props.inmueblesData.properties && this.props.inmueblesData.type_filter === 0 && this.props.isProperties ? (
          <SidebarPropertiesSus
            ref = {this.propertiesRef}
            colorsData={this.props.colorsData}
            inmueblesData={this.props.inmueblesData}
            attributesFilterObject={this.state.attributesFilterObject}
            handleUpdateFilterObject={this.handleUpdateFilterObject}
            handlePropertiesFilter={this.props.handlePropertiesFilter}
            avalabilityAttributesToShow={this.props.avalabilityAttributesToShow}
            handleFilterAvailability={this.props.handleFilterAvailability}
            handleMenuSelection={this.props.handleMenuSelection}
            handleClearFilters={this.handleClearFilters}
            isProperties={this.props.isProperties}
            hasDispo={this.props.hasDispo}
            isDetailed={this.state.isDetailed}
            detailedGroupID = {this.props.detailedGroupID}
            currentDetailed={this.props.isDetailed}
            wordToShow={this.state.wordToShow}
            layoutsRef = {this.props.layoutsRef}
            handleHideTooltip = {this.props.handleHideTooltip}
          />
        ) : null}
        {this.state.isDetailed ? (
          <div className={this.props.isSalaVentasMode ?"detailed-flag-sala-de-ventas":"detailed-flag"}>
            <div
              className="detailed-close-container"
              onClick={() => {
                this.setState({ isDetailed: false });
                this.props.handleCloseDetailedSpin();
              }}
            >
              <img src={close} alt="" />
            </div>
            <hr />
            {this.props.isDetailed.group ?
              <div className="detailed-group-name">
                {this.props.isDetailed.group.replace(/\d+/g, (match: any) => ` ${match} `)}
              </div>:null
            }
          </div>
        ) : null}
      </div>
    );
  }
}

export default PropertiesContainer;
